import { useContext } from 'react';
import { VideoControlContext } from '../VideoControlContext';

export const useVideoControl = () => {
  const context = useContext(VideoControlContext);

  if (!context) {
    throw new Error('useVideoControl must be used within a VideoControlProvider');
  }

  return context;
};
